import dayjs, { Dayjs } from 'dayjs'
import { AvailabilityContract } from 'models'
import { API_TIME_SPAN_FORMAT } from './availabilityHelper'
export const checkAvailability = (
    availability: AvailabilityContract,
    toDay: Dayjs | string,
) => {
    if (!availability) return true
    if (typeof toDay === 'string') toDay = dayjs(toDay)

    let isAvailableDay = checkAvailableDays(toDay, availability)
    let isDateRange = checkDateRange(toDay, availability)
    let isTimeRange = checkTimeRange(toDay, availability)

    return isDateRange && isTimeRange && isAvailableDay
}
const checkAvailableDays = (
    toDay: dayjs.Dayjs,
    availability: AvailabilityContract,
) => {
    let isAvailableDay = true
    let availableDays = availability.availableDays?.split(';') ?? []
    // for availableDays != [";"] , []
    if (availableDays.length > 1)
        isAvailableDay = availableDays.includes(toDay.day().toString())
    return isAvailableDay
}

const checkTimeRange = (toDay: Dayjs, availability: AvailabilityContract) => {
    let startTime = availability.startTime
        ? dayjs(availability.startTime, API_TIME_SPAN_FORMAT)
        : dayjs().add(-1, 'day')

    let endTime = availability.endTime
        ? dayjs(availability.endTime, API_TIME_SPAN_FORMAT)
        : dayjs().add(1, 'day')
    //make endTime always after start time e.g 16.00-1.00 next day
    if (endTime.isBefore(startTime)) endTime = endTime.add(1, 'day')
    return toDay.isBetween(startTime, endTime, 'minute', '[]')
}

const checkDateRange = (toDay: Dayjs, availability: AvailabilityContract) => {
    let startDate = availability.startDate
        ? dayjs(availability.startDate).startOf('day')
        : dayjs().add(-1, 'day')
    let endDate = availability.endDate
        ? dayjs(availability.endDate).endOf('day')
        : dayjs().add(1, 'day')
    return toDay.isBetween(startDate, endDate, 'day', '[]')
}
